import Vue from 'vue';

const state = {
    keys: {}
};

const getters = {
    getKeys() {
        return state.keys;
    }
};

const mutations = {
    setTaskItem(state, item) {
        debugger
        Vue.set(state.keys, item.ticketNo, item)
    }
};

const actions = {

};

export default {
    state,
    mutations,
    actions,
    getters
}


